import { actions, assign, raise } from "xstate"
import { ECommerceEvent } from "../e-commerce-machine"
import { assertEvent } from "../../../../../_common/xstate-helpers"
import { ECommerceContext } from "../e-commerce-machine-context"

type Context = ECommerceContext
type Events = ECommerceEvent

export const webQuoteActions = {
    setWebQuoteGuestInfo: actions.pure<Context, Events>((_, ev) => {
        assertEvent(ev, "VALIDATE_WEB_QUOTE")
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { type, ...rest } = ev
        return [
            assign<Context, Events>(() => ({
                webQuoteGuestInfo: ev.mainGuest,
                quoteTrackingId: ev.trackingData.trackingId,
            })),
            raise({ type: "VALIDATING_WEB_QUOTE", ...rest }),
        ]
    }),

    setWebQuoteResponse: assign<Context, Events>({
        webQuoteResponse: (_, ev) => {
            assertEvent(ev, "WEB_QUOTE_VALIDATED")
            return ev.response
        },
    }),
}
